import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Channels.css';
const channelMeta = [
    { key: 'vk', name: 'VK', hint: 'Написать в сообщество' },
    { key: 'max', name: 'MAX', hint: 'Открыть чат в MAX' },
    { key: 'site', name: 'Сайт', hint: 'Виджет на сайте' },
    { key: 'phone', name: 'Телефон', hint: 'Позвонить агенту' },
];
export function Channels({ title, lead, mode, links }) {
    return (_jsxs("section", { className: `channels channels--${mode}`, children: [_jsxs("header", { className: "channels__intro", children: [_jsx("span", { className: "section__eyebrow", children: mode === 'demo' ? 'Демо' : 'Заявки' }), _jsx("h2", { className: "channels__title", children: title }), _jsx("p", { className: "channels__lead", children: lead })] }), _jsx("ul", { className: "channels__list", children: channelMeta.map((channel) => {
                    const href = links[channel.key];
                    const isPhone = channel.key === 'phone';
                    const label = isPhone ? links.phoneLabel : channel.name;
                    const isPlaceholder = href === '#' || href === '#contact';
                    return (_jsx("li", { children: _jsxs("a", { className: "channel", href: href, ...(href.startsWith('http')
                                ? { target: '_blank', rel: 'noreferrer' }
                                : {}), children: [_jsx("span", { className: "channel__name", children: label }), _jsx("span", { className: "channel__hint", children: isPlaceholder && !isPhone ? `${channel.hint} · ссылка скоро` : channel.hint })] }) }, channel.key));
                }) })] }));
}
